export default "__VITE_ASSET__7267d03b__"